export const QUERY__ONBOARDINGS = 'onboardings';
export const QUERY__ONBOARDING = 'onboarding';
export const QUERY__USER_ONBOARDING_STATUSES = 'user-onboarding-statuses';
